import cvi from './cvi';

const borders = {
  main: `1px solid ${cvi.neutrals[40]}`,
  subtle: `1px solid ${cvi.neutrals[30]}`,
};

export default borders;
